import { useState, useRef, useEffect } from "react";

const VideoSection = ({ videoSrc, children }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const videoRef = useRef(null);

    useEffect(() => {
        if (isLoaded && videoRef.current) {
            videoRef.current.play().catch((error) => console.error("Autoplay failed:", error));
        }
    }, [isLoaded]);

    return (
        <section className="relative flex flex-col gap-5 items-center justify-center min-h-[100dvh] w-full snap-start overflow-hidden">
            {/* Vidéo en arrière-plan */}
            <video
                ref={videoRef}
                autoPlay
                loop
                muted
                playsInline
                className={`absolute top-0 left-0 w-full h-full object-cover z-0 transition-opacity duration-500 ${isLoaded ? "opacity-100" : "opacity-0"
                    }`}
                onLoadedData={() => setIsLoaded(true)}
            >
                <source src={videoSrc} type="video/mp4" />
                
            </video>

            {/* Loader */}
            {!isLoaded && (
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-10">
                    <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
            )}

            {/* Contenu au premier plan */}
            <div className="relative z-10 flex flex-col items-center">{children}</div>
        </section>
    );
};

export default VideoSection;
